import { apiClient } from "@/lib/api";
import { Customer } from "@/types/customers";

export const createCustomer = async (body: Omit<Customer, "id" | "status" | "created_at" | "updated_at"> & Partial<Pick<Customer, "status">>) =>
  apiClient<Customer>("/customers", { method: "POST", body });

export const updateCustomer = async (id: string, body: Partial<Omit<Customer, "id" | "created_at" | "updated_at">>) =>
  apiClient<Customer>(`/customers/${id}`, { method: "PUT", body });

export const deleteCustomer = async (id: string) =>
  apiClient<void>(`/customers/${id}`, { method: "DELETE" });

export const fetchCustomers = async (q?: string, status?: string): Promise<Customer[]> => {
  const params: Record<string, string> = {};
  if (q) params.q = q;
  if (status) params.status = status;
  return apiClient<Customer[]>("/customers", {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
};

export const fetchCustomerById = async (id: string): Promise<Customer> => {
  return apiClient<Customer>(`/customers/${id}`);
};

// Roster-based options for the sales-rep assignment dropdown: active
// Sales-department employees (the staff managed in account admin settings).
export const fetchAssignableSalesReps = async (): Promise<string[]> => {
  return apiClient<string[]>("/customers/assignable-sales-reps");
};
